module.exports = __webpack_public_path__ + "static/media/hanakawado-asakusa-2.92dc1a29.jpg";